import React from 'react';
import {
  Dialog,
  Box,
  Typography,
  Button,
  useTheme,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/images/onlylogo_kali.svg';
import LogoWhite from '../assets/images/only_logo_white.svg';
import Slide from '@mui/material/Slide';
import {useMediaQuery } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AuthDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    sessionStorage.setItem("pendingQuestion", "true");
  };

  return (
    <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth={!isMobile ? true : false}
        slots={{
            transition: Slide,
        }}
        slotProps={{
            transition: {
            direction: isMobile ? "up" : "down",
            },
            backdrop: {
            sx: {
                backdropFilter: "blur(1px)",
                backgroundColor: "rgba(0,0,0,0.2)",
            },
            },
            paper: {
            sx: {
                borderRadius: isMobile ? "10px 10px 0 0" : "10px",
                border: '1px solid #bababa',
                position: isMobile ? "fixed" : "relative",
                bottom: isMobile ? 0 : "auto",
                left: isMobile ? 0 : "auto",
                right: isMobile ? 0 : "auto",
                m: isMobile ? 0 : 2,
                width: isMobile ? "100%" : "auto",
                minWidth: isMobile ? "100%" : 530,
                p: 3,
                boxShadow: null,
                backgroundImage: "none",
                backgroundColor: theme.palette.background.default,
            },
            },
        }}
    >
      {/* Divider with Floating Logo */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: 2,
          mb: 4,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            height: '1px',
            backgroundColor: 'divider',
            flex: 1,
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            width: 60,
            height: 60,
            borderRadius: '8px',
            backgroundColor: theme.palette.background.default,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 1,
          }}
        >
          <Box
            component="img"
            src={theme.palette.mode === 'dark' ? LogoWhite : Logo}
            sx={{ width: 48, height: 48 }}
          />
        </Box>

        <Box
          sx={{
            height: '1px',
            backgroundColor: 'divider',
            flex: 1,
          }}
        />
      </Box>

      {/* Title */}
      <Typography
        variant="h2"
        sx={{
          fontSize: 'clamp(20px,2.5vw,26px)',
          textAlign: 'center',
        }}
      >
        Continue with <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="h4"
        sx={{
          fontSize: '14px',
          mx: 'auto',
          maxWidth: 320,
          mb: 4,
          mt: -1.5,
          textAlign: 'center',
        }}
      >
        To use <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> and unlock deeper insights, create an account or log
        into an existing one.
      </Typography>

      {/* Buttons */}
      <Stack spacing={2} sx={{ px: 6, width: '100%' }} justifyContent="center" alignItems="center" display="flex">
        <Button
          variant="contained"
          color="secondary"
          size="large"
          fullWidth
          sx={{
            borderRadius: '999px',
            py: 1.4,
            fontWeight: 500,
          }}
          onClick={() => {
              handleLoginRedirect();
              navigate('/signin');
          }
        }
        >
          Sign up
        </Button>

        <Button
          variant="outlined"
          size="large"
          color="primary"
          fullWidth
          sx={{
            borderRadius: '999px',
            py: 1.4,
            textTransform: 'none',
            fontWeight: 500,
            color: theme.palette.text.primary,
            borderColor: theme.palette.text.primary,
            '&:hover': {
              borderColor: theme.palette.text.primary,
              backgroundColor: theme.palette.action.hover,
            },
          }}
          onClick={() => {
            handleLoginRedirect();
            navigate('/login');
         }}
        >
          Sign in
        </Button>
      </Stack>
    </Dialog>
  );
};

export default AuthDialog;